.card {
  display: flex;
  flex-direction: column;
  min-inline-size: 0;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface);
}

.header {
  display: flex;
  gap: var(--space-4);
  align-items: flex-start;
  justify-content: space-between;
  padding: var(--space-4) var(--space-4) 0;
}

.heading {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-inline-size: 0;
}

.title {
  font-size: var(--text-lg);
  font-weight: var(--weight-semibold);
}

.description {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.actions {
  display: flex;
  flex: none;
  gap: var(--space-2);
  align-items: center;
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-4);
  min-inline-size: 0;
}

.card[data-padding="flush"] .body {
  padding: var(--space-3) 0 0;
}
